import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PageCaregiverView } from "./pageCaregiverView";
import { PageCaregiverAdd } from "./pageCaregiverAdd";
import { PageCaregiverUpdate } from "./pageCaregiverUpdate";
import { PageSingleComponent } from "./pageSingleCaregiver";
import { RedirectRoute } from "../../../components/redirectRoute";
import { PageCaregiverAddPatient } from "./PageCaregiverAddPatient";

export function PageCaregiver(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Caregiver.List()}
          exact
          component={PageCaregiverView}
        />
        <Route
          path={AppRouteUi.Caregiver.Add()}
          exact
          component={PageCaregiverAdd}
        />
        <Route
          path={AppRouteUi.Caregiver.Update()}
          exact
          component={PageCaregiverUpdate}
        />
        <Route
          path={AppRouteUi.Caregiver.AddPatient()}
          exact
          component={PageCaregiverAddPatient}
        />
        <Route
          path={AppRouteUi.Caregiver.ById()}
          exact
          component={PageSingleComponent}
        />
        <RedirectRoute
          from={AppRouteUi.Caregiver.Root()}
          to={AppRouteUi.Caregiver.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
